export default __webpack_public_path__ + "static/media/apple.ba7eb694.mp3";